import * as React from 'react';
import { ApolloError } from 'apollo-client';
import { Error, Loader } from '.';

// FC components break when referencing React.ReactNode types for props
// https://stackoverflow.com/questions/54905376/type-error-jsx-element-type-null-undefined-is-not-a-constructor-functi

type GqlStateHandlerProps = {
  loading?: boolean | React.ReactNode;
  error?: boolean | React.ReactNode | ApolloError;
  customLoader?: any;
  customError?: any;
};

const GqlStateHandler: React.FC<GqlStateHandlerProps> = ({ loading, error, children, customLoader, customError }) => {
  if (loading) {
    return customLoader || <Loader />;
  }
  if (error) {
    return customError || <Error />;
  }
  return children;
};

export default GqlStateHandler;



// WEBPACK FOOTER //
// ./src/components/GqlStateHandler.tsx